/**
 * PV/UV 埋点工具
 * 在路由 afterEach 中调用 trackPV() 上报页面访问
 */
import config from '@/config/config'
import axios from 'axios'

const TRACK_API = config.BASE_URL + '/statistics/track/pv'
const SESSION_KEY = '_hlw_session_id'

/**
 * 获取或生成 session_id（存 localStorage，每次会话唯一）
 */
function getSessionId() {
    let sessionId = localStorage.getItem(SESSION_KEY)
    if (!sessionId) {
        sessionId = generateUUID()
        localStorage.setItem(SESSION_KEY, sessionId)
    }
    return sessionId
}

/**
 * 生成 UUID v4
 */
function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0
        const v = c === 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
    })
}

/**
 * 从 URL 中解析 query 参数
 */
function getQueryParam(url, key) {
    try {
        // 兼容 hash 路由：从 hash 后面取参数
        const hashIndex = url.indexOf('#')
        let search = ''
        if (hashIndex > -1) {
            const hashPart = url.substring(hashIndex + 1)
            const qIndex = hashPart.indexOf('?')
            if (qIndex > -1) {
                search = hashPart.substring(qIndex)
            }
        } else {
            const qIndex = url.indexOf('?')
            if (qIndex > -1) {
                search = url.substring(qIndex)
            }
        }
        const params = new URLSearchParams(search)
        return params.get(key) || ''
    } catch (e) {
        return ''
    }
}

/**
 * 上报 PV
 * @param {Object} to - Vue Router 的 route 对象
 */
export function trackPV(to) {
    try {
        const fullUrl = window.location.href
        const utmSource   = getQueryParam(fullUrl, 'utm_source')
        const utmCampaign = getQueryParam(fullUrl, 'utm_campaign')
        const emailLogId  = getQueryParam(fullUrl, 'email_log_id')
        const emailType   = getQueryParam(fullUrl, 'email_type')

        // 获取已登录用户ID（从 localStorage 取 token 对应的用户信息）
        let userId = 0
        try {
            const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
            userId = userInfo.id || 0
        } catch (e) {}

        const data = {
            page: to.path || '/',
            session_id: getSessionId(),
            user_id: userId,
            utm_source: utmSource,
            utm_campaign: utmCampaign,
            email_log_id: emailLogId ? parseInt(emailLogId) : 0,
            email_type: emailType ? parseInt(emailType) : 0,
            referer: document.referrer || '',
        }

        // 异步上报，不阻塞页面
        axios.post(TRACK_API, data).catch(() => {
            // 静默失败，不影响用户体验
        })
    } catch (e) {
        // 埋点出错不影响页面正常运行
    }
}

export default { trackPV }
